import { Injectable, Optional } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Configuration } from '../configuration';
import { AbstractApiController } from './abstract-api-controller';
import { LanguageStateService } from '../../../services/language-state.service';

@Injectable()
export class TaxiEarningsApi extends AbstractApiController {

  constructor(
    private http: HttpClient,
    private langStorage: LanguageStateService,
    @Optional() config?: Configuration
  ) {
    super();
    this.baseUrl = (config && config.apiBaseUrl)
      ? config.apiBaseUrl + `/${this.langStorage.getLang()}`
      : 'https://example.com';
  }

  public getLastEarnings() {
    return this.http.get<any>(
      this.baseUrl + `/api/cf/personal-area/taxi-earnings/last`,
      {headers: this.getAuthHeaders()}
    );
  }

  public getEarnings(page, limit, filter= {}) {
    return this.http.get<any>(
      this.prepareListRequest(
        this.baseUrl + `/api/cf/personal-area/taxi-earnings`,
        page,
        limit,
        [{periodTo: 'DESC'}],
        filter
      ),
      {headers: this.getAuthHeaders()}
    );
  }
}
